import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import env from '../../config/env';


const ViewIdentityProof = ({open,handleCloseIP,title, image}) => {
  return (
    <Dialog open={open} onclose={handleCloseIP} fullWidth maxWidth='md'>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent dividers style={{display:'flex', justifyContent:'center', alignItems:'center',padding:'20px'}}>
            <Box>
                <img src={`${env.backend_api_endpoint}/files/${image}`}
                     alt="Identity Proof"
                     style={{maxWidth:"100%",maxHeight:"80vh", borderRadius:"10px"}}
                />
            </Box>
        </DialogContent>
        <DialogActions>
            <Button  onClick={handleCloseIP} variant='outlined'>Close</Button>
        </DialogActions>
    </Dialog>
  )
}

export default ViewIdentityProof